// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2l2UQ","container":"styles_container__12IGu","language":"styles_language__EeZKb","text":"styles_text__23rUC","dropdown":"styles_dropdown__1oCOi"};